import React, { Component } from 'react';
import styled from 'styled-components';

import SocialSection from '../components/Index/SocialSection';
import Sections from '../components/Index/Sections';
import Footer from '../components/Index/Footer';
import Header from '../components/Index/Header';
import HeroSection from '../components/Index/Hero';
import FloatingButton from '../components/UI/Buttons/FloatingButton';
import { Posts } from '../components/Index/Posts';

class IndexPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      headerFixed: false,
    };
  }

  render() {
    const { node: home } = this.props.data.home.edges[0];
    const { menu, social } = this.props.data.header.edges[0].node;
    const {
      networks,
      title: socialTitle,
      floatingButton,
    } = this.props.data.social.edges[0].node;
    const { footerContent } = this.props.data.footer.edges[0].node;
    const { edges: posts } = this.props.data.posts;
    const { node: form } = this.props.data.form.edges[0];

    // Css

    const MainStyle = styled.main`
      background-color: #fff;
      overflow-x: hidden;
    `;

    const CentralStyle = styled.div`
      background-color: #fff;
      position: relative;
      z-index: 1;
      padding-top: 1rem;
    `;

    const dataForms = {
      ...form.constItens,
      itensForm: form.itensForm,
    };

    return (
      <React.Fragment>
        <FloatingButton icon={floatingButton.icon} url={floatingButton.url} />
        <MainStyle id="main_Element">
          <HeroSection title={home.title} />
          <Header menu={menu} social={social} />
          <CentralStyle>
            <Sections propSections={home.sections} propDataForm={dataForms} />
            <div id="network_Element">
              <Posts posts={posts} />
              <SocialSection networks={networks} title={socialTitle} />
            </div>
          </CentralStyle>
        </MainStyle>
        <div id="footer_Element">
          <Footer footerContent={footerContent} />
        </div>
      </React.Fragment>
    );
  }
}

export default IndexPage;

export const query = graphql`
  query IndexPageQuery {
    home: allDataJson(filter: { name: { eq: "index" } }) {
      edges {
        node {
          sections {
            sectionID
            title
            description
            hexagoncolor
            cta
            ctatype
            link
            servicos {
              icon
              color
              description
            }
          }
        }
      }
    }
    header: allDataJson(filter: { name: { eq: "header" } }) {
      edges {
        node {
          name
          menu {
            name
            link
          }
          social {
            icon
            link
          }
        }
      }
    }
    social: allDataJson(filter: { name: { eq: "social" } }) {
      edges {
        node {
          title
          networks {
            icon
            color
            url
          }
          floatingButton {
            icon
            url
          }
        }
      }
    }
    footer: allDataJson(filter: { name: { eq: "footer" } }) {
      edges {
        node {
          footerContent {
            address
            email
            fone
          }
        }
      }
    }
    posts: allWordpressPost {
      edges {
        node {
          excerpt
          title
          link
          date
        }
      }
    }
    form: allDataJson(filter: { name: { eq: "form" } }) {
      edges {
        node {
          constItens {
            textWhatsApp
            IOEmail
            text
            linkWhatsApp
          }
          itensForm {
            sectionID
            itens {
              name
              type
            }
            hiddenItens {
              name
              type
            }
          }
        }
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/pages/index.jsx